import Heading from "components/Heading/Heading";
import { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import VectorImg from "images/vectors/VectorHIW.svg";

export interface SectionHowItWorkProps {
  className?: string;
  heading: string;
  description: string;
  data?: {
    id: number;
    title: string;
    description: string;
    img: string;
    imgDark?: string;
  }[];
}


const SectionHowItWork: FC<SectionHowItWorkProps> = ({
  heading,
  description,
  data,
  className = "",
}) => {


  return (
    <div
      className={`nc-SectionHowItWork  ${className}`}
      data-nc-id="SectionHowItWork"
    >
      <Heading isCenter desc={description}>
        {heading}
      </Heading>
      <div className="mt-20 relative grid md:grid-cols-3 gap-20">
        <img
          className="hidden md:block absolute inset-x-0 top-10"
          src={VectorImg}
          alt=""
        />
        {data.map((item, index) => (
          <div
            key={`item-${index}-${item.title}`}
            className="relative flex flex-col items-center max-w-xs mx-auto"
          >
            {item.imgDark ? (
              <>
                <NcImage
                  containerClassName="dark:hidden block mb-8 max-w-[200px] mx-auto"
                  src={item.img}
                />
                <NcImage
                  containerClassName="hidden dark:block mb-8 max-w-[200px] mx-auto"
                  src={item.imgDark}
                />
              </>
            ) : (
              <NcImage
                containerClassName="mb-8 max-w-[200px] mx-auto"
                src={item.img}
              />
            )}
            <div className="text-center mt-auto">
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <span className="block mt-5 text-neutral-500 dark:text-neutral-400">
                {item.description}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWork;
